(() => {
  const init = (root = document) => {
    const sections = root.querySelectorAll ? root.querySelectorAll('[data-evermont-contact]') : [];
    sections.forEach((section) => {
      if (section.dataset.contactReady === 'true') return;
      section.dataset.contactReady = 'true';
      const types = section.querySelectorAll('[data-inquiry-type]');
      const productBox = section.querySelector('[data-product-fields]');
      const productFields = section.querySelectorAll('[data-product-required]');
      const messageLabel = section.querySelector('[data-message-label]');
      const messageInput = section.querySelector('[data-message-input]');
      const messageHelp = section.querySelector('[data-message-help]');

      const sync = () => {
        const selected = section.querySelector('[data-inquiry-type]:checked');
        const product = selected?.value === 'Product inquiry';
        const store = selected?.value === 'Store inquiry';
        if (productBox) productBox.hidden = !product;
        productFields.forEach((field) => {
          field.disabled = !product;
          field.required = product;
        });
        if (messageLabel) messageLabel.innerHTML = product
          ? 'Project details <b>*</b>'
          : store ? 'How can we help? <b>*</b>' : 'Your message <b>*</b>';
        if (messageInput) messageInput.placeholder = product
          ? 'Describe style, sizing, colours, timeline and branding requirements.'
          : store ? 'Describe the store issue and what you need help with.' : 'Tell us how we can help.';
        if (messageHelp) messageHelp.textContent = product
          ? 'Product, order size, leather preference and project details are required.'
          : 'Please include enough detail for our team to direct your inquiry correctly.';
      };
      types.forEach((input) => input.addEventListener('change', sync));
      sync();
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (event) => {
    init(event.target);
    init(document);
  });
})();
